.error-details {
	background-color: var(--ds-background-neutral, var(--adg3-color-N40));
	padding: 10px;
	border-radius: 5px;
	white-space: pre-wrap;
	word-wrap: break-word;
}
